import { RootState } from "@core/store"

export const memberSelector = (state: RootState) => state.member.member

// export const clickInfoSelector = (state: RootState) =>
//   state.renderControl.clickInfo
